<template>
  <div class="event-list">
    <home-event-list-item class="item"
      v-for="(item, index) in data" :key="index" :data="item"></home-event-list-item>
  </div>
</template>

<script>
import HomeEventListItem from '@/components/news-monitor/HomeEventListItem';

export default {
  props: {
    data: {
      type: Array
    }
  },
  components: {
    HomeEventListItem
  }
};
</script>

<style lang="scss" scoped>
  .event-list {
    overflow-y: auto;
    height: 304px;
    padding: 4px 0 15px 0;
    background-color: #3e3c42;
  }
</style>

